export const AXA_CATEGORIES_VIP = Object.freeze([
    "VIP",
]);

export const AXA_CATEGORIES_NOT_VISIBLE = Object.freeze([
    "CUIDADO INTEGRAL",
    "VIP - CUIDADO INTEGRAL",
]); 